module.exports = __webpack_public_path__ + "img/math_plus.90b1a352.svg";